import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './components/login/login.component';
import { LoginGuard } from './service/login.guard';
import { HomepageComponent } from './components/homepage/homepage.component';
import { AuthenticationGuard } from './service/authentication.guard';

const routes: Routes = [
  {
    path: '',
    component: HomepageComponent,
    canActivate: [AuthenticationGuard],
  },
  {
    path: 'login',
    component: LoginComponent,
    canActivate: [LoginGuard],
  },
  {
    path: 'risk-dashboard',
    loadChildren: () =>
      import('./components/functions/limit-manager/limit-manager.module').then(
        (m) => m.LimitManagerModule,
      ),
  },
  {
    path: 'cash-movements',
    loadChildren: () =>
      import(
        './components/functions/cash-movements/cash-movements.module'
      ).then((m) => m.CashMovementsModule),
  },
  {
    path: 'stp',
    loadChildren: () =>
      import('./components/functions/stp/stp.module').then((m) => m.StpModule),
  },
  {
    path: 'accounts',
    loadChildren: () =>
      import('./components/functions/accounts/accounts.module').then(
        (m) => m.AccountsModule,
      ),
  },
  {
    path: 'rates',
    loadChildren: () =>
      import('./components/functions/rates/rates.module').then(
        (m) => m.RatesModule,
      ),
  },
  {
    path: 'posting-methods',
    loadChildren: () =>
      import(
        './components/functions/posting-methods/posting-methods.module'
      ).then((m) => m.PostingMethodsModule),
  },
  {
    path: 'commission',
    loadChildren: () =>
      import('./components/functions/commission/commission.module').then(
        (m) => m.CommissionModule,
      ),
  },
  {
    path: 'swaptrade-poster',
    loadChildren: () =>
      import(
        './components/functions/swaptrade-poster/swaptrade-poster.module'
      ).then((m) => m.SwaptradePosterModule),
  },
  {
    path: 'huobi',
    loadChildren: () =>
      import('./components/functions/huobi/huobi.module').then(
        (m) => m.HuobiModule,
      ),
  },
  {
    path: 'crypto-address',
    loadChildren: () =>
      import(
        './components/functions/crypto-address/crypto-address.module'
      ).then((m) => m.CryptoAddressModule),
  },
  {
    path: 'cash-movement-reconciliation',
    loadChildren: () =>
      import(
        './components/functions/cash-movements-reconciliation/cash-movements-reconciliation.module'
      ).then((m) => m.CashMovementsReconciliationModule),
  },
  {
    path: 'downloads',
    loadChildren: () =>
      import('./components/functions/downloads/downloads.module').then(
        (m) => m.DownloadsModule,
      ),
  },
  {
    path: 'statistic-dashboard',
    loadChildren: () =>
      import(
        './components/functions/statistic-dashboard/statistic-dashboard.module'
      ).then((m) => m.StatisticDashboardModule),
  },
  {
    path: 'golden-records',
    loadChildren: () =>
      import(
        './components/functions/golden-records/golden-records.module'
      ).then((m) => m.GoldenRecordsModule),
  },
  {
    path: 'diff-tool',
    loadChildren: () =>
      import('./components/functions/diff-tool/diff-tool.module').then(
        (m) => m.DiffToolModule,
      ),
  },
  {
    path: 'redis-limits',
    loadChildren: () =>
      import(
        './components/functions/redis-interface/redis-interface.module'
      ).then((m) => m.RedisInterfaceModule),
  },
  {
    path: 'haircut',
    loadChildren: () =>
      import('./components/functions/haircut/haircut.module').then(
        (m) => m.HaircutModule,
      ),
  },
  {
    path: 'ynb-limit-stream',
    loadChildren: () =>
      import(
        './components/functions/ynb-limit-stream/ynb-limit-stream.module'
      ).then((m) => m.YnbLimitStreamModule),
  },
  {
    path: '**',
    pathMatch: 'full',
    redirectTo: 'login',
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      useHash: true,
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
